import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import ServiceTypePill from "@/components/ui/common/service-type-pill";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import EndpointRow from "./endpoint-row";

const EndpointList = ({ endpoints = [], groupLabel }) => (
	<div className="bg-transparent">
		{groupLabel && (
			<div className="text-xs text-gray-400 font-semibold px-3 py-1.5 bg-accent/30 border-b border-border/30">{groupLabel}</div>
		)}
		{endpoints.length === 0 ? (
			<div className="text-gray-500 text-sm px-3 py-4 text-center">No endpoints</div>
		) : (
			endpoints.map((ep, i) => <EndpointRow key={i} endpoint={ep} />)
		)}
	</div>
);

const EndpointDetailModal = ({ open, onOpenChange, serviceName, data }) => {
	if (!data) return null;

	const isProducerOnly = data.serviceType === "PRODUCER";
	const isConsumerOnly = data.serviceType === "CONSUMER";
	const isDual = data.serviceType === "CONSUMER_PRODUCER";

	const showTabs = isDual;

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="max-w-3xl max-h-[80vh] overflow-hidden flex flex-col">
				<DialogHeader>
					<div className="flex items-center gap-2">
						<DialogTitle>{serviceName}</DialogTitle>
						<ServiceTypePill type={data.serviceType} />
					</div>
				</DialogHeader>

				<div className="overflow-y-auto flex-1 -mx-6 px-6">
					{!showTabs && (
						<div className="border border-border/30 rounded overflow-hidden bg-transparent">
							{isProducerOnly && <EndpointList endpoints={data.producer?.endpoints} />}
							{isConsumerOnly &&
								data.consumer?.map((service, i) => (
									<EndpointList
										key={i}
										endpoints={service.endpoints}
										groupLabel={data.consumer.length > 1 ? `Target: ${service.target}` : undefined}
									/>
								))}
						</div>
					)}

					{showTabs && (
						<Tabs defaultValue="exposed">
							<TabsList className="grid w-full grid-cols-2 gap-0 mb-3">
								<TabsTrigger value="exposed">Exposed Endpoints</TabsTrigger>
								<TabsTrigger value="called">Consumed Endpoints</TabsTrigger>
							</TabsList>
							<TabsContent value="exposed">
								<div className="border border-border/30 rounded overflow-hidden bg-transparent">
									<EndpointList endpoints={data.producer?.endpoints} />
								</div>
							</TabsContent>
							<TabsContent value="called">
								<div className="border border-border/30 rounded overflow-hidden bg-transparent">
									{data.consumer?.map((service, i) => (
										<EndpointList
											key={i}
											endpoints={service.endpoints}
											groupLabel={data.consumer.length > 1 ? `Target: ${service.target}` : undefined}
										/>
									))}
								</div>
							</TabsContent>
						</Tabs>
					)}
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default EndpointDetailModal;
